<template>
  <div>
    <template v-if="is_edit">
      <div class="page-content__header__title">
        <h1>
          {{ $t('shared.task_edit') }}{{ curernt_task.id }} {{ $t('shared.from') }} {{ date_from }}
        </h1>
        <div class="mt--4">
          <caller
            v-if="
              /* eslint-disable vue/html-indent */
              curernt_task.customer_phone &&
              /* eslint-disable vue/html-indent */
              callType != 'progressive' &&
              user.group_id == curernt_task.group_id
            "
            :size="36"
            :number="curernt_task.customer_phone"
            :task_id="curernt_task.id"
            :user_id="user.id"
            :status="status"
          />
          <caller-progressive v-if="callType == 'progressive'" :size="36" />
        </div>
      </div>
    </template>
    <z-form ref="form" class="w-100">
      <div class="row">
        <div class="d-flex col-12 mb-0">
          <base-form
            class="col-5"
            ref="customer_form"
            v-model="form"
            :is_edit="is_edit"
            :current_task="curernt_task"
            @base_form="getBaseInfo"
          />
          <general-information
            class="col-4 ml-4"
            ref="general_form"
            v-model="general_form"
            :is_edit="is_edit"
            :current_task="curernt_task"
            :states_list="statesList"
            @general_form="getGeneralInfo"
          />
          <default-scripts class="col ml-4" v-if="is_edit" :project_id="curernt_task.project_id" />
        </div>
        <div class="d-flex col-12">
          <card-cart
            class="col-5"
            ref="cart_items"
            :is_edit="is_edit"
            :cart_items="cart_items"
            @cart_items="parseCartItems"
          />
        </div>
        <div v-if="!!history.length" class="d-flex col-12">
          <card-history
            class="col-9"
            :is_edit="is_edit"
            :items="history"
            :status_list="statesList"
            :user_list="usersList"
            :is_loading="is_history_loading"
          />
        </div>
      </div>

      <div class="row mt-2 text-right">
        <div class="col-12">
          <template v-if="callType != 'progressive'">
            <v-btn class="btn-cancel" @click="$router.go(-1)">
              {{ $t('tasks.campaign.form.cancel_btn') }}
            </v-btn>
            <v-btn
              v-if="callType !== 'progressive'"
              class="btn-success"
              raised
              color="#394858"
              size="large"
              :loading="is_loading_save"
              @click="save"
            >
              {{ $t('shared.component.button.save') }}
            </v-btn>
          </template>
          <template v-if="callType === 'progressive'">
            <v-btn
              class="btn-success ml-3"
              raised
              color="#394858"
              size="large"
              :loading="is_loading_complete"
              @click="complete"
            >
              {{ $t('tasks.campaign.form.save_compelete_btn') }}
            </v-btn>
          </template>
        </div>
      </div>
    </z-form>
  </div>
</template>
<script>
  import BaseForm from './base-form';
  import CardCart from './card-cart';
  import CardHistory from './card-history';
  import Caller from '@shared/components/caller';
  import CallerProgressive from '@shared/components/caller-progressive';
  import GeneralInformation from './general-information';
  import DefaultScripts from './default-scripts';
  import { TasksService } from '@tasks/services/TasksService';
  import { StatusesService } from '@administration/services/StatusesService';
  import { UsersService } from '@administration/services/UsersService';
  import { toFrontendDateWithTime } from '@shared/helpers/date_format';
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment-timezone';

  export default {
    components: {
      BaseForm,
      DefaultScripts,
      CardCart,
      CardHistory,
      GeneralInformation,
      Caller,
      CallerProgressive
    },
    props: {
      allow_call: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      is_loading_save: false,
      is_loading_complete: false,
      is_history_loading: false,
      recipients: {
        recipients: [],
        include: [],
        exclude: []
      },
      form: {},
      general_form: {},
      cart_items: JSON.stringify({}),
      is_edit: false,
      curernt_task: {},
      status: '',
      history: {},
      statesList: [],
      usersList: {}
    }),

    computed: {
      ...mapGetters('core/auth', ['user']),
      ...mapGetters('tasks/caller', ['callType']),
      ...mapGetters('tasks/task_card', ['is_delayed_status']),

      date_from() {
        return toFrontendDateWithTime(this.curernt_task.created_at);
      }
    },
    async created() {
      const { id: task_id } = this.$router.history.current.params;
      this.is_history_loading = true;

      if (task_id) {
        const id_from_url = window.location.pathname.split('/')[3];
        const id = task_id ? task_id : id_from_url;

        await TasksService.getItemTask(id)
          .then((resp) => {
            this.curernt_task = resp;
            this.cart_items = JSON.parse(resp.items);
            this.is_edit = true;
          })
          .catch((e) => console.log(e));

        await this.updateHistory(id);
      }

      await StatusesService.getList().then((resp) => (this.statesList = resp.data));
      await UsersService.getList().then((resp) => (this.usersList = resp.data));
    },
    beforeDestroy() {
      this.$eventHub.$emit('hangup');
    },
    methods: {
      ...mapActions('tasks/caller', ['setCallType']),

      updateHistory(id) {
        TasksService.getTaskHistory(id)
          .then((data) => {
            this.history = data.sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
          })
          .catch((e) => {
            this.$noty.server_error(e);
          })
          .finally(() => (this.is_history_loading = false));
      },

      getBaseInfo(info) {
        this.form = info;
      },

      getGeneralInfo(info) {
        this.general_form = info;
      },

      parseCartItems(items) {
        this.cart_items = items;
      },

      async save() {
        this.status = 'hangup';
        const is_valid = await this.$refs.form.validate();

        this.$refs.customer_form.returnInfo();
        this.$refs.general_form.returnInfo();
        this.$refs.cart_items.returnItems();

        const params = {
          group_id: this.general_form.group_id,
          task_state_id: this.general_form.task_state_id ? this.general_form.task_state_id : null,
          task_id: this.general_form.task_id,
          task_date: toFrontendDateWithTime(this.general_form.task_date),
          items: JSON.stringify(this.cart_items),
          comments: this.form.comments,
          customer_email: this.form.customer_email,
          customer_name: this.form.customer_name,
          customer_phone: this.form.customer_phone.replaceAll(/[-+]|\s|/g, ''),
          customer_country: this.form.customer_country,
          customer_region: this.form.customer_region,
          customer_city: this.form.customer_city,
          customer_address: this.form.customer_address,
          customer_zip: this.form.customer_zip,
          project_id: this.general_form.project_id,
          delayed_until: this.is_delayed_status
            ? toFrontendDateWithTime(this.general_form.delayed_until)
            : null
        };
        if (params.task_date == 'Invalid date') {
          delete params.task_date;
        } else if (this.is_edit) {
          params.task_date = moment(params.task_date)
            .tz('Atlantic/Azores')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        if (is_valid) {
          this.is_loading_save = true;
          if (this.is_edit) {
            return await TasksService.updateItem(this.curernt_task.id, params)
              .then(() => {
                this.$noty.success(this.$t('tasks.campaign.update_data'));
                this.updateHistory(this.curernt_task.id);
              })
              .catch((e) => {
                console.log(e.response.data);
                this.$noty.server_error(e);
              })
              .finally(() => (this.is_loading_save = false));
          }

          return await TasksService.createItem(params)
            .then(() => {
              if (this.$route.name === 'project.tasks.create') {
                this.$router.push({
                  name: 'projects.tasks.list',
                  params: { project_id: this.general_form.project_id }
                });
              } else {
                this.$router.push({ name: 'tasks.list' });
              }
            })
            .catch((e) => {
              this.$noty.server_error(e);
              console.log(e.response.data);
            })
            .finally(() => (this.is_loading_save = false));
        }
      },

      async complete() {
        this.status = 'hangup';
        const is_valid = await this.$refs.form.validate();

        this.$refs.customer_form.returnInfo();
        this.$refs.general_form.returnInfo();
        this.$refs.cart_items.returnItems();

        const params = {
          group_id: this.general_form.group_id,
          task_state_id: this.general_form.task_state_id ? this.general_form.task_state_id : null,
          task_id: this.general_form.task_id,
          task_date: toFrontendDateWithTime(this.general_form.task_date),
          items: JSON.stringify(this.cart_items),
          comments: this.form.comments,
          customer_email: this.form.customer_email,
          customer_name: this.form.customer_name,
          customer_phone: this.form.customer_phone.replaceAll(/[-+]|\s|/g, ''),
          customer_country: this.form.customer_country,
          customer_region: this.form.customer_region,
          customer_city: this.form.customer_city,
          customer_address: this.form.customer_address,
          customer_zip: this.form.customer_zip,
          project_id: this.general_form.project_id,
          delayed_until: this.is_delayed_status
            ? toFrontendDateWithTime(this.general_form.delayed_until)
            : null
        };

        if (params.task_date == 'Invalid date') {
          delete params.task_date;
        } else if (this.is_edit) {
          params.task_date = moment(params.task_date)
            .tz('Atlantic/Azores')
            .format('YYYY-MM-DD HH:mm:ss');
        }

        if (is_valid) {
          this.is_loading_complete = true;
          return await TasksService.updateCompleteItem(this.curernt_task.id, params)
            .then(() => {
              this.$noty.success(this.$t('tasks.campaign.update_data'));
              this.$router.go(-1);
            })
            .catch((e) => {
              console.log(e.response.data);
              this.$noty.server_error(e);
            })
            .finally(() => {
              if (this.callType == 'progressive') {
                TasksService.updateCallCompleteItem(this.curernt_task.id);
                this.$eventHub.$emit('hangup');
                this.$eventHub.$emit('call');
                this.setCallType('');
              }
              this.is_loading_complete = false;
            });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .mt--4 {
    margin-top: -20px;
  }
</style>
